import { translate, type TFunc } from "../i18n/i18n";

// "N servings" for display (localised + pluralised), or null when servings is
// unset (N/A) so callers can omit it. Mirrors formatDuration returning "N/A" —
// but here null = hide. Pass a `t` (from useT) at display sites so the label
// re-renders on a language switch; defaults to the current language otherwise.
export function formatServings(
  servings?: number | null,
  t: TFunc = translate,
): string | null {
  if (!servings) return null;
  return t("recipe.servingsCount", { count: servings });
}
